export default __webpack_public_path__ + "static/media/licenseFront.0e83d40d.svg";